// require('./scss/styles.scss');
var $ = require("jquery");
var selectric = require("./jquery.selectric.js");
var slick = require("slick-carousel");
var cookies = require("js-cookie");
var Isotope = require("isotope-layout");
var bridget = require('jquery-bridget');
bridget( 'isotope', Isotope, $ );

var L = require("leaflet");

var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var iphone = /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

$(function() {
    if(ios) {
        if(iphone) {
            $('body').css('background-size', '200%');
        }
        $('body').css('background-position', '50% 0px');
        $(document).scroll(function() {
            $('body').css('background-position', '50% ' + $(document).scrollTop() + 'px');
        })
    }
    $(document).scroll(function() {
        if($(document).scrollTop() > 100) {
            $("header").addClass("header--scroll");
        } else {
            $("header").removeClass("header--scroll");
        }
    });
    $('.menu > div > .overlay').click(function(e) {
        $('.menupart--active').fadeOut();
        $(this).parent().addClass('menupart--active');
        e.preventDefault();
    });
    $('.menubutton, main .overlay, .menu > .overlay').click(function(e) {
        e.preventDefault();
        $('.menu, .menubutton').toggleClass('menu--active');
        $('main .overlay, .menu > .overlay').fadeToggle();
        if(!$('.menu').hasClass('menu--active')) {
            $('.menu > div').removeClass('menupart--active').show().last().addClass('menupart--active');
            $('.menu > .overlay').hide();
        }
    });
    // //Todo: Cookie: If already in area
    // if(!cookies.get('folded')) {
    //     if($(".menu3").length) {
    //         $(".level2 header, .level3 header, .level4 header").delay(2500).queue(function(next) {
    //             cookies.set('folded', true, {path:location.pathname});
    //             $(this).addClass("fold-menu2");
    //             next();
    //         });
    //     }
    // }
    // $(document).on("click", "header.fold-menu2 .menu2", function() {
    //     $('header').toggleClass('fold-menu2');
    // });

    // $("select").selectric({
    //     responsive:true,
    //     disableOnMobile:false
    // })
    $(".filterform select").change(function() {
        $(this.form).submit();
    });

    $(".menu2-select select").change(function() {
        if(this.value) {
            location.href=this.value;
        }
    })

    $(".teaserslider").slick({
        vertical:true,
        verticalSwiping:true,
        speed:200,
        prevArrow: "",
        adaptiveHeight:true
    });

    $(".contentslider").slick({
        speed:200,
        dots:true,
        nextArrow:".slick-next",
        prevArrow:".slick-prev",
        appendDots:".contentslider_nav_dots"
    });

    $(window).resize(function() {
        $('.teaserslider').each(function() {
            this.slick.refresh();
        })
    })
    // console.log($("select").selectric);
    // selectric($("select"));

    if($('.content_newslist--dynamic').length) {
        var $iso = $( '.content_newslist--dynamic').isotope();

        $(".tags li").click(function() {
            if($(this).hasClass("tag--active")) {
                $iso.isotope({filter: ""});
                $(".tags li").removeClass("tag--active");
            } else {
                $(".tags li").not($(this)).removeClass("tag--active");
                $iso.isotope({filter: ".subject-"+$(this).data("filter")})
                $(this).addClass("tag--active");
            }
        })
    }

    $(".mapcontainer").each(function() {
        var map = L.map('map', {
            closePopupOnClick: false,
            scrollWheelZoom: false
        });
        if($(this).hasClass("mapcontainer--event")) {
            //Only one mapitem
            var $mapitem = $(".mapitem").first();
            var lat = $mapitem.data("lat");
            var lng = $mapitem.data("lng");
            map.setView([lat,lng], 11);
        } else {
            map.setView([54.23152,9.66797], 8);
        }
        // var osmUrl='http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
        var osmUrl='https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png';
        var osmAttrib='Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors';
        var osm = new L.TileLayer(osmUrl, {attribution: osmAttrib});
        map.addLayer(osm);

        var template = '<h3>$Name</h3>'
        +'<a href="$Url"><img src="$Image"/></a>'
        +'<p><a href="$Url">Seite öffnen</a></p>';

        $(".mapitem").each(function() {
            var lat = $(this).data("lat");
            var lng = $(this).data("lng");
            var categories = $(this).data("categories");
            var firstcat = $(this).data("firstcat");
            var content= $(this).html();

            var icon = L.divIcon({
                className: 'map-marker ',
                iconSize:null,
                html:'<div class="mapicon mapicon--'+firstcat+'" data-categories="'+categories+'"></div>'
            });

            var latlng = [lat, lng];

            var marker = L.marker(latlng, {icon: icon}).on('click', function() {
                //var popup = this.getPopup();
                //this.openPopup()
                //alert("ding");
            });
            marker.bindPopup(content, {'maxWidth':219});

            marker.addTo(map);
        });

        $("#mapfilter li").click(function() {
            $("#mapfilter li").not($(this)).removeClass("tag--active");
            $(this).toggleClass("tag--active");

            var filter = $(this).data("filter");
            if($(this).hasClass("tag--active")) {
                $(".maptable tr, .mapicon").each(function() {
                    if($(this).data("categories").search(filter) == -1) {
                        $(this).hide();
                    } else {
                        $(this).show();
                    }
                })
            } else {
                $(".maptable tr, .mapicon").show();
            }
        })
        $(".morelink").click(function() {
            $("#"+$(this).data("link")).toggle();
        });
    })
});
